import React, { PropsWithChildren } from 'react'
import { getClassNames } from '../../../_utils/classnames'

interface INotificationBuilderMain {
    className?: string
}

const NotificationBuilderMain: React.FunctionComponent<PropsWithChildren<INotificationBuilderMain>> = (props) => {
    const { className, children } = props

    return <div className={getClassNames('notification-builder-main', className)}>{children}</div>
}

export default NotificationBuilderMain
